import React from "react";
import {CardImg} from "reactstrap";
import {canUseWebP} from "../../utils/Utilities";
import PropTypes from "../../utils/propTypes";

class MyCardImage extends React.Component{

    render() {
        let {src, emptyTextWarning} = this.props
        if(src && src.includes("base64")){
            // Base 64 nothing to do
        }else{
            if(canUseWebP()){
                src = src+"?webp=true"
            }else{
                src = src+"?webp=false"
            }
        }
        return(
            this.props.src?(
                <CardImg className="img-fluid shadow" {...this.props} src={src}/>
            ):(
                <span className="text-muted text-center fs-5">{emptyTextWarning}</span>
            )
        )
    }
}

MyCardImage.propTypes = {
    style: PropTypes.any,
    src: PropTypes.string,
    className:PropTypes.any,
    noWebp:PropTypes.bool,
    alt:PropTypes.string,
    emptyTextWarning:PropTypes.string,
};


export default MyCardImage